import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Alert,
  Box,
} from '@mui/material';
import { contactsAPI } from '../api';

function JoinContactDialog({ open, onClose, inviterUsername, inviteDigits, preview, onJoinSuccess }) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const inviterName = preview?.inviterUsername || inviterUsername || 'this user';

  const handleJoin = async () => {
    if (!inviterUsername || !inviteDigits) return;

    setLoading(true);
    setError(null);
    try {
      const response = await contactsAPI.join(inviterUsername, inviteDigits);
      if (onJoinSuccess) {
        onJoinSuccess(response.data);
      }
      onClose();
      window.location.reload();
    } catch (error) {
      console.error('Failed to add contact:', error);
      setError(error.response?.data?.error || 'Failed to add contact');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Add Contact</DialogTitle>
      <DialogContent>
        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}
        
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
          <Typography variant="body1">
            <strong>{inviterName}</strong> invited you as a direct contact.
          </Typography>
          <Typography variant="body2" color="text.secondary">
            You can chat one-on-one without joining a team.
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={loading}>
          Cancel
        </Button>
        <Button onClick={handleJoin} variant="contained" disabled={loading}>
          {loading ? 'Adding...' : 'Add Contact'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default JoinContactDialog;
